<template>
  <div class="faq-container">
    <div class="answer-container">
      <div v-for="(item, i) in faq" :key="i" class="answer-item">
        <div class="answer-outer">
          <div class="answer-inner">
            <div class="answer-question" :title="item.question">
              {{ item.question }}
            </div>
            <div class="answer-text" v-html="item.answer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaqSection",
  props: {
    faq: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activePanel: 0,
    };
  },
  methods: {
    togglePanel(index) {
      this.activePanel = index;
    },
    isActivePanel(index) {
      return this.activePanel === index;
    },
  },
};
</script>

<style scoped lang="scss">
.faq-section {
  position: relative;
  overflow: hidden;
}

.title.big {
  margin-bottom: 45px;
}

.faq-container {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.question-inactive,
.question-inner {
  padding: 16px 21px 15px 18px;
}

.questions-container {
  width: 100%;
  max-width: 507px;
  display: flex;
  flex-direction: column;

  .question-item {
    cursor: pointer;
    width: 100%;

    & + .question-item {
      margin-top: 12px;
    }

    &.active + .question-item:not(.active) {
      margin-top: 6px;
    }

    &:not(.active) + .question-item.active {
      margin-top: 6px;
    }

    &.active {
      .question-outer {
        height: 63px;
        border-radius: 2px;
        border: 1px solid #15ca5c;
        padding: 6px;

        .question-inner {
          max-width: 495px;
          height: 51px;
          border-radius: 2px;
          background: #15ca5c1a;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;

          .question-text {
            font-family: "Montserrat", sans-serif;
            font-size: 16px;
            font-weight: 700;
            line-height: 19.5px;
            text-align: left;
            color: #15ca5c;
            max-width: 90%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .question-index {
            font-family: "Montserrat", sans-serif;
            font-size: 16px;
            font-weight: 700;
            line-height: 19.5px;
            text-align: right;
            color: #15ca5c;
          }
        }
      }
    }

    .question-inactive {
      background: #191919;
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 495px;
      margin: 0 auto;
      gap: 20px;

      .question-text {
        font-family: "Montserrat", sans-serif;
        font-size: 16px;
        font-weight: 700;
        line-height: 19.5px;
        text-align: left;
        color: white;
        max-width: 440px;
        /* added max-width */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .question-index {
        font-family: "Montserrat", sans-serif;
        font-size: 16px;
        font-weight: 700;
        line-height: 19.5px;
        text-align: right;
        color: #ffffff40;
        border-radius: 4px;
      }
    }
  }
}

.answer-container {
  padding: 12px;
  border: 1px solid #191919;
  overflow: hidden;

  .answer-item {
    .answer-outer {
      height: 100%;
      width: 100%;
      border: 1px solid #191919;
      border-radius: 2px;

      .answer-inner {
        background: #191919;
        padding: 42px 34px;

        .answer-question {
          font-family: "Montserrat", sans-serif;
          font-size: 16px;
          font-weight: 700;
          line-height: 20px;
          text-align: left;
          color: #15ca5c;
          margin-bottom: 24px;

          max-width: 100%;
          max-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-clamp: 2;
        }

        .answer-text {
          font-family: "Roboto", sans-serif;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          color: #b7b8c1;
          overflow-y: auto;
          // word-break: break-all;
          text-wrap: wrap;
          text-overflow: ellipsis;
          // white-space: nowrap;
          // word-wrap: break-word;
          // white-space: pre-wrap;
          max-height: 170px;
        }

        ::v-deep(.answer-text) {
          ul,
          ol {
            padding-left: 20px;
            margin-bottom: 10px;
            margin-left: 10px;
          }

          ul {
            list-style-type: disc;
          }

          ol {
            list-style-type: decimal;
          }

          strong {
            font-weight: bold;
          }

          em {
            font-style: italic;
          }

          a {
            color: #6462ff;
            text-decoration: underline;
          }
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .questions-container {
    max-width: 400px;
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .faq-container {
    flex-direction: column;
  }

  .questions-container {
    width: 100%;
    max-width: 100%;
  }

  .questions-container .question-item.active .question-outer .question-inner,
  .questions-container .question-item .question-inactive {
    max-width: 100%;
  }

  .answer-container {
    margin-top: 20px;
    flex: 0;
  }

  .answer-container .answer-item .answer-outer .answer-inner {
    padding: 12px;
  }
}
</style>
